import React, { Component } from "react";
import { Grid, Paper } from "@material-ui/core";
import LeftPanel from "./LeftPanel";
import RightPanel from "./RightPanel";
import AddButton from "./AddButton";

export default class AdminProgramme extends Component {
  state = {
    selectedNode: null,
    refreshKey: 0,
  };

  handleSelectNode = (node) => {
    this.setState({ selectedNode: node });
  };

  refreshTree = () => {
    this.setState({ refreshKey: this.state.refreshKey + 1 });
  };

  render() {
    return (
      <div style={{ padding: 20 }}>
        <h2 style={{ marginBottom: 20 }}>Programmes Offered — Content Management</h2>

        <Grid container spacing={2}>
          <Grid item xs={12} sm={4} md={3}>
            <Paper style={{ padding: 15, height: "80vh", overflowY: "auto" }}>
              <LeftPanel
                key={this.state.refreshKey}
                onSelect={this.handleSelectNode}
                apikey={this.props.apikey}
              />
              <AddButton floating={false} parentId={null} refresh={this.refreshTree} apikey={this.props.apikey} />
            </Paper>
          </Grid>

          <Grid item xs={12} sm={8} md={9}>
            <Paper style={{ padding: 20, minHeight: "80vh" }}>
              <RightPanel
                selected={this.state.selectedNode}
                refresh={this.refreshTree}
                apikey={this.props.apikey}
              />
            </Paper>
          </Grid>
        </Grid>

        <AddButton floating={true} parentId={(this.state.selectedNode ? this.state.selectedNode.id : null) || null} refresh={this.refreshTree} apikey={this.props.apikey} />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/Components/AdminProgramme/AdminProgramme.js